import React from 'react';

import { CommunityPreferenceType } from 'types/communities';

import CommunitySettingLabel from '../../CommunitySettingLabel';
import { COMMUNITY_LABEL_COLOR, MARKET_RATE_COMPARISON_UPDATES } from '../../constants';

type Props = {
  item: CommunityPreferenceType;
};

const getMarketRateComparisonLabel = (item: CommunityPreferenceType) => {
  const overRate = item.preferences?.market_rate_comparison_rate_over;
  const underRate = item.preferences?.market_rate_comparison_rate_under;
  const hasOverRate = overRate !== null && overRate !== undefined;
  const hasUnderRate = underRate !== null && underRate !== undefined;

  if (hasUnderRate && !hasOverRate) {
    return `When ${underRate}% under competitors' rate`;
  }

  if (hasOverRate && !hasUnderRate) {
    return `When ${overRate}% over competitors' rate`;
  }

  if (hasOverRate && hasUnderRate) {
    if (underRate === overRate) {
      return `When ${underRate}% over or under competitors' rate`;
    }

    return `When ${overRate}% over or ${underRate}% under competitors' rate`;
  }

  return MARKET_RATE_COMPARISON_UPDATES.statusElements.ON.label;
};

const MarketRateComparisonStatus = ({ item }: Props) => {
  const { statusElements } = MARKET_RATE_COMPARISON_UPDATES;

  if (item.preferences?.market_rate_comparison_updates) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
        <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.POSITIVE}>{getMarketRateComparisonLabel(item)}</CommunitySettingLabel>
        <span style={{ color: 'var(--gray-dark)', fontSize: 12 }}>
          {item.receiving_notification_users_no}/{item.total_users_no} users receiving
        </span>
      </div>
    );
  }

  return <CommunitySettingLabel color={COMMUNITY_LABEL_COLOR.NEUTRAL}>{statusElements.OFF.label}</CommunitySettingLabel>;
};

export default MarketRateComparisonStatus;
